import React from 'react'
import ACard from '../../components/partials/ACard'

export default function NotFound() {
  return (
    <div>
     <ACard>

     <h1 className='text-red-900 text-center flex items-center justify-center mt-20'  >Page Not Found</h1>
    </ACard>
     </div>
  )
}
